import { render } from "./ManageCare.vue?vue&type=template&id=5ebf4d8b&lang=pug"
import script from "./ManageCare.vue?vue&type=script&lang=js"
export * from "./ManageCare.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__